/*
 * @Author: Bai.Zhiming
 * @Date: 2017-8-21
 * @LastEditTime: 2021-03-25 20:09:55
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\resourceCenter\left\left.js
 * @Description:  版权资源（原资源中心）左侧导航
 */
'use strict';
angular
    .module('resourceCenterLeftModule', ['shareLeftModule', 'leftStartAniModule', 'resourceCenterXinhuaModule'])
    .controller('resourceCenterLeft', [
        '$scope',
        '$q',
        '$timeout',
        '$element',
        '$state',
        'publicToolService',
        'trsHttpService',
        'resourceCenterService',
        'modalDialog',
        'stockApiService',
        'xinhuaApiService',
        'messagePublishService',
        function($scope, $q, $timeout, $element, $state, publicToolService, trsHttpService, resourceCenterService, modalDialog, stockApiService, xinhuaApiService, messagePublishService) {
            initStatus();
            initData();

            /**
             * [initStatus description] 初始化状态
             * @return {[type]} [description]
             */
            function initStatus() {
                $scope.status = {
                    expandedLeve1: [],
                    selected: '',
                    myManuscriptLibrary: '',
                };
                $scope.data = {
                    share: {},
                    materials: {},
                    mediaresource: {},
                    xinhua: {},
                    xjrb: {},
                    propagandaData: {},
                    multiMediaResource: [
                        {
                            name: '图片素材',
                            routerPart: 'multimediaresource.picture',
                            key: 'tpg',
                        },
                        {
                            name: '视频素材',
                            routerPart: 'multimediaresource.video',
                            key: 'tpg',
                        },
                    ],
                    tenantManuscriptResource: [
                        {
                            name: '收到',
                            routerPart: 'tenantManuscriptResource.receive',
                        },
                        {
                            name: '发出',
                            routerPart: 'tenantManuscriptResource.post',
                        },
                    ],
                    xinhuaThirdClassify: {
                        1: [{
                            nodename: '通稿新闻线路',
                            fcode: '1',
                        }, {
                            nodename: '新媒体专线（文字）',
                            fcode: '2'
                        }, {
                            nodename: '公鉴',
                            fcode: '3'
                        }],
                        2: [{
                            nodename: '彩色通稿',
                            fcode: '1',
                        }, {
                            nodename: '新媒体专线（图片）',
                            fcode: '2'
                        }, {
                            nodename: '外带图片一线',
                            fcode: '3'
                        }, {
                            nodename: '国内专稿组',
                            fcode: '4'
                        }, {
                            nodename: '法新专线',
                            fcode: '5'
                        }, {
                            nodename: '讲文明树新风公益广告',
                            fcode: '6'
                        }]
                    },
                    xinhuaClassify: []
                };
            }

            /**
             * [initData description] 初始化数据
             * @return {[type]} [description]
             */
            function initData() {
                publicToolService.getModeconfiguration('resourceLeftShield', 'copyrightResource').then((config) => {
                    $scope.status.navigationShield = config;
                });

                publicToolService.getModeconfiguration('myManuscriptLibrary', 'copyrightResource').then((config) => {
                    $scope.status.myManuscriptLibrary = config || '新疆日报稿库';
                });
                getPermissionData().then(() => {
                    autoLocation();
                });
            }

            /**
             * [autoLocation description] 路由自动定位
             * @return {[type]} [description]
             */
            function autoLocation() {
                let routerName = $state.current.name;
                let routerArray = routerName.split('.');
                let timer; // 延时器
                if (routerName === 'front.resourcectrl') {
                    // 当权限数据完成，节点加载完毕，以模拟点击dom的形式，去打开加载完成的头一个节点，完成自动定位
                    let $leve1 = $element.find('.leve1').eq(0);
                    if ($leve1.length >= 0) {
                        let $a = $leve1.find('a').eq(0);
                        timer = $timeout(() => {
                            $a[0].click();
                            timer = $timeout(() => {
                                // 检查二级菜单，先用1秒钟，等其加载完成后，再模拟点击事件
                                let $a_child = $a.next('ul').find('li>a');
                                if ($a_child.length > 0) {
                                    $a_child[0].click();
                                }
                            });
                        });
                    }
                } else {
                    let sign = routerArray[2];
                    if (sign === 'share') {
                        // 共享稿库
                        $scope.selectShareLeve1();
                    } else if (sign === 'xinhua') {
                        // 新华社稿
                        $scope.expandxinhuaSecondClassify().then(function(data) {
                            var selected = data.filter((item) => $state.params.parentfcode === item.TENANTXHSTYPEID);
                            $scope.selectXinhuaLeve2(selected.length ? selected[0] : data[0]);
                        });
                    } else if (sign === 'xjrb') {
                        // 新疆日报稿库
                        $scope.expandXJRBClassify();
                    } else if (sign === 'material') {
                        // 素材库
                        $scope.expandMaterialClassify().then(() => {
                            $scope.selectMaterialLeve2(
                                $scope.data.materialClassify.filter((item, index) => item.fcode === $state.params.parentfcode)[0],
                                false
                            );
                        });
                    } else if (sign === 'stock') {
                        // 新疆日报历史稿库
                        if ($state.params.historystore) {
                            $scope.selectXjrbHistoryStore();
                            return;
                        }
                        // 成品稿库
                        $scope.expandStockClassify().then(() => {
                            $scope.selectStockLeve2($scope.data.stockClassify.filter((item, index) => item.fcode === $state.params.fcode)[0], false);
                        });
                    } else if (sign === 'theme') {
                        // 主题稿库
                        $scope.selectThemeClassify();
                    } else if (sign === 'multimediaresource') {
                        // 多媒体资源
                        $scope.expandLeve1('multimediaresource').then(() => {
                            $scope.selectMultiMediaResourceLeve2(
                                $scope.data.multiMediaResource.filter((item, index) => $state.current.name.indexOf(item.routerPart) >= 0)[0]
                            );
                        });
                    } else if (sign === 'materials') {
                        // 公共素材库
                        $scope.selectMaterialsLeve1();
                    } else if (sign === 'mediaresource') {
                        // 媒资库
                        $scope.selectMediaResourceLeve1();
                    } else if (sign === 'tenantmanuscript') {
                        $scope.expandLeve1('tenantmanuscript').then(function() {
                            $scope.selectTenantManuscriptResourceLeve2(
                                $scope.data.tenantManuscriptResource.filter((item, index) => item.routerPart.indexOf(routerArray[3]) > 0)[0]
                            );
                        });
                    } else if (sign === 'propagandamanuscript') {
                        $scope.selectedPropagadaLeve1();
                    }
                }
                $scope.$on('$destroy', () => {
                    $timeout.cancel(timer);
                });
            }

            /**
             * [getPermissionData description] 获取权限数据
             * @return {[type]} [description]
             */
            function getPermissionData() {
                let deffer = $q.defer();
                let timer; // 延时器
                let params = {
                    serviceid: 'mlf_metadataright',
                    methodname: 'queryOperTypesBySourceModal',
                    Classify: 'source',
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then((data) => {
                    $scope.data.permissionData = (function() {
                        var obj = {};
                        for (var i in data) {
                            var name = data[i];
                            obj[name] = true;
                        }
                        return obj;
                    })();
                    timer = $timeout(() => {
                        deffer.resolve();
                    });
                });
                $scope.$on('$destroy', () => {
                    $timeout.cancel(timer);
                });
                return deffer.promise;
            }

            /**
             * [selectShareLeve1 description] 选中共享稿库一级菜单
             * @return {[type]} [description]
             */
            $scope.selectShareLeve1 = function() {
                let deffer = $q.defer();
                getShareLeve1Classify().then(
                    () => {
                        $scope.$root.narrowNavigation = false; // 宽导航
                        deffer.resolve();
                    },
                    () => {
                        $scope.$root.narrowNavigation = true; // 窄导航
                        deffer.resolve();
                    }
                );
                resourceCenterService.memoryEchoOnlyLevel1('front.resourcectrl.share');
                $scope.status.selected = 'share';
                return deffer.promise;
            };

            /**
             * [getShareLeve1Classify description] 获取共享稿库一级分类
             * @return {[type]} [description]
             */
            function getShareLeve1Classify() {
                let deffer = $q.defer();
                if ($scope.data.share.value && angular.isArray($scope.data.share.value) && $scope.data.share.value.length > 0) {
                    deffer.resolve();
                    return deffer.promise;
                }
                let params = {
                    serviceid: 'mlf_sharedoc',
                    methodname: 'queryCategorysWithRight',
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(
                    (data) => {
                        if (data && angular.isArray(data) && data.length > 0) {
                            $scope.data.share.value = data;
                            deffer.resolve();
                        } else {
                            deffer.reject();
                        }
                    },
                    () => {
                        deffer.reject();
                    }
                );
                return deffer.promise;
            }

            /**
             * [expandStock description] 展开成品稿库
             * @return {[type]} [description]
             */
            /**
             * [expandStockClassify description] 展开成品稿库
             * @param   {[object]}  e  [e description] 事件对象
             * @return  {[type]}       [return description]
             */
            $scope.expandStockClassify = function(e) {
                let deffer = $q.defer();
                getStockClassify().then(() => {
                    $scope.expandLeve1('stock', e);
                    deffer.resolve();
                });
                return deffer.promise;
            };

            /**
             * [getStockClassify description] 获取成品稿库分类
             * @return {[type]} [description]
             */
            function getStockClassify() {
                let deffer = $q.defer();
                if (!$scope.data.stockClassify || $scope.data.stockClassify.length == 0) {
                    let params = stockApiService.getChannelsParams();
                    $scope.loadingPromise = stockApiService.getChannels(params).then(function(data) {
                        $scope.data.stockClassify = data.content;
                        deffer.resolve();
                    });
                } else {
                    deffer.resolve();
                }
                return deffer.promise;
            }

            /**
             * [stockLeftShow description] 成品稿库的三级菜单是否展示
             * @return {[type]} [description]
             */
            $scope.stockLeftShow = function() {
                if (!angular.isArray($scope.data.stockClassify) || $scope.data.stockClassify.length == 0) {
                    return false;
                }
                return $scope.data.stockClassify.some(
                    (item) => item.fcode == $scope.status.selected && angular.isArray(item.value) && item.value.length > 0
                );
            };

            /**
             * [selectStockLeve2 description] 成品稿库选中二级菜单
             * @param  {[type]} item [description] 菜单信息
             * @param {boolean} [reload] [description] 是否重载
             * @return {[type]}      [description]
             */

            $scope.selectStockLeve2 = function(item, reload) {
                let deffer = $q.defer();
                getStockLeve3Classify(item).then(
                    () => {
                        $scope.$root.narrowNavigation = false; // 宽导航
                        deffer.resolve();
                    },
                    () => {
                        $scope.$root.narrowNavigation = true; // 窄导航
                        deffer.resolve();
                    }
                );
                $scope.status.selected = item.fcode;
                if (reload === false) {
                    return deffer.promise;
                }
                let url = '';
                if (item.fcode === 'video') {
                    url = 'front.resourcectrl.stock.video';
                } else if (item.fcode === 'audio') {
                    url = 'front.resourcectrl.stock.audio';
                } else {
                    url = 'front.resourcectrl.stock.resource';
                }
                resourceCenterService.go(url, {
                    media_id: '',
                    fcode: item.fcode,
                    change: Math.random(0, 1) * 100,
                    historystore: ''
                });
                return deffer.promise;
            };

            /**
             * [getStockLeve3Classify description] 获取成品稿库三级节点分类
             * @param   {[type]}  item  [item description]
             * @return  {[type]}        [return description]
             */
            function getStockLeve3Classify(item) {
                let deffer = $q.defer();
                if (item.value) {
                    deffer.resolve();
                } else {
                    let params = {
                        serviceid: 'navigation',
                        typeid: 'zyzx',
                        modelid: 'getProductMedia',
                        fcode: item.fcode,
                    };
                    $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post').then(
                        (data) => {
                            if (data && angular.isArray(data.content) && data.content.length > 0) {
                                item.value = data.content;
                                deffer.resolve();
                            } else {
                                deffer.reject();
                            }
                        },
                        () => {
                            deffer.reject();
                        }
                    );
                }
                return deffer.promise;
            }

            /**
             * [getStockSelectedLeve2Info description] 获取选中的成品稿库二级分类信息
             * @return {[type]} [description]
             */
            $scope.getStockSelectedLeve2Info = function() {
                if (!$scope.stockLeftShow()) {
                    return {};
                }
                return $scope.data.stockClassify.filter((item) => item.fcode == $scope.status.selected)[0];
            };

            /**
             * [expandThemeClassify description] 展开主题稿库
             * @return  {[type]}  [return description]
             */
            $scope.selectThemeClassify = function() {
                resourceCenterService.memoryEchoOnlyLevel1('front.resourcectrl.theme');
                $scope.status.selected = 'theme';
                $scope.$root.narrowNavigation = false; // 窄导航
                // const url = 'front.resourcectrl.theme.resource';
                // resourceCenterService.go(url);
            };

            /**
             * [expandxinhuaSecondClassify description] 展开新华社稿
             * @param   {[type]}  e  [e description]
             * @return  {[type]}     [return description]
             */
            $scope.expandxinhuaSecondClassify = function(e) {
                var defer = $q.defer();
                if ($scope.data.xinhuaClassify.length) { // 如果已经请求到了，则不再进行请求
                    $scope.expandLeve1('xinhua', e);
                    defer.resolve($scope.data.xinhuaClassify);
                    return defer.promise;
                }
                xinhuaApiService.getXinhuaClassfiy().then(function(data) {
                    $scope.data.xinhuaClassify = data;
                    $scope.expandLeve1('xinhua', e);
                    defer.resolve(data);
                });
                return defer.promise;
            };

            /**
             * [selectXinhuaLeve2 description] 展开新华社二级导航
             * @param   {[object]}  nav  [item description] 导航信息
             * @return  {[type]}         [return description]
             */
            $scope.selectXinhuaLeve2 = function(nav){
                $scope.data.xinhua.value = nav; // $scope.data.xinhuaClassify.third[nav.value];
                $scope.status.selected = 'xinhua' + nav.TENANTXHSTYPEID; // nav.TENANTXHSTYPEID;
                // var basicNav = $scope.data.xinhua.value[0];
                $scope.$root.narrowNavigation = false; // 宽导航
                // let params = {
                //     fcode: basicNav.fcode,
                //     nodename: basicNav.nodename,
                //     doctype: nav.value
                // };
                messagePublishService.publish('xinhuaThridNavChange'); // 默认切回通告（有数据）
                // resourceCenterService.go('front.resourcectrl.xinhua.resource', params);
                // getxinhuaSecondClassifyNew().then(
                //     (item) => {
                //         $scope.$root.narrowNavigation = false; // 宽导航
                //         let params = {
                //             fcode: $state.params.fcode||,
                //             nodename: item.nodename,
                //             doctype: nav.value,
                //             // fcode: item.fcode,
                //             // nodename: item.nodename,
                //             // doctype: nav.value,
                //         };
                //         messagePublishService.publish('xinhuaThridNavChange', true);
                //         resourceCenterService.go('front.resourcectrl.xinhua.resource', params);
                //     },
                //     function() {
                //         $scope.$root.narrowNavigation = true; // 窄导航
                //     }
                // );
            };

            /**
             * [expandXJRBClassify description] 展开新疆日报稿库
             * @return {[type]} [description]
             */
            $scope.expandXJRBClassify = function() {
                getXJRBClassifyNew().then(
                    (item) => {
                        $scope.$root.narrowNavigation = false; // 宽导航
                        let params = {
                            fcode: item.fcode,
                            nodename: item.nodename,
                        };
                        $scope.status.selected = 'xjrb';
                        resourceCenterService.go('front.resourcectrl.xjrb.resource', params);
                    },
                    function() {
                        $scope.$root.narrowNavigation = true; // 窄导航
                        $scope.status.selected = 'xjrb';

                    }
                );
            };

            /**
             * [xinhuaLeftShow description] 新华社稿的三级菜单是否展示
             * @return {[type]} [description]
             */
            $scope.xinhuaLeftShow = function() {
                if (!angular.isArray($scope.data.xinhuaClassify.second) || $scope.data.xinhuaClassify.second.length == 0) {
                    return false;
                }
                return $scope.data.xinhuaClassify.second.some(
                    (item) => item.fcode == $scope.status.selected && angular.isArray(item.value) && item.value.length > 0
                );
            };

            /**
             * [selectXinhuaLeve2 description] 新华社稿选中二级菜单
             * @param  {[type]} item [description] 菜单信息
             * @param {boolean} [varname] [description] 是否重载页面
             * @return {[type]}      [description]
             */

            // $scope.selectXinhuaLeve2 = function(item, reload) {
            //     let deffer = $q.defer();
            //     if (angular.isArray(item.value) && item.value.length > 0) {
            //         $scope.$root.narrowNavigation = false; // 宽导航
            //     } else {
            //         $scope.$root.narrowNavigation = true; // 窄导航
            //     }
            //     $scope.status.selected = item.fcode;
            //     if (reload === false) {
            //         deffer.resolve();
            //         return deffer.promise;
            //     }
            //     var params = {
            //         typename: 'xlfl', // 固化为线路分类
            //         modalid: 41, // 新华社稿固化为41
            //         belong: item.belong,
            //         nodename: item.name,
            //         change: Math.random(),
            //         ispic: item.name == '图片线路',
            //         fcode: item.fcode,
            //         parentbelong: item.belong,
            //         parentfcode: item.fcode,
            //         imgflag: item.imgflag,
            //     };
            //     if (item.name === '图片线路') {
            //         $state.go('front.resourcectrl.xinhua.resource', params, { reload: 'front.resourcectrl.xinhua.resource' });
            //     } else {
            //         resourceCenterService.go('front.resourcectrl.xinhua.resource', params);
            //     }
            //     deffer.resolve();
            //     return deffer.promise;
            // };

            /**
             * [getXinhuaSelectedLeve2Info description] 获取选中的新华社二级分类信息
             * @return {[type]} [description]
             */
            $scope.getXinhuaSelectedLeve2Info = function() {
                if (!$scope.xinhuaLeftShow()) {
                    return {};
                }
                return $scope.data.xinhuaClassify.second.filter(
                    (item) => item.fcode === $scope.status.selected && angular.isArray(item.value) && item.value.length > 0
                )[0];
            };

            /**
             * [selectTenantManuscriptResourceLeve2 description] 选中租户间稿库的二级分类
             * @param {[object]} [item] [description] 被选中的二级分类
             * @return {[type]} [description]
             */
            $scope.selectTenantManuscriptResourceLeve2 = function(item) {
                let deffer = $q.defer();
                // $scope.$root.narrowNavigation = false; //宽导航
                getTenantManuscriptLeve3Classify(item).then(
                    () => {
                        $scope.$root.narrowNavigation = false; // 宽导航
                        $scope.status.selected = item.routerPart;
                        // if (item.routerPart == "tenantManuscriptResource.post") {
                        //     $state.go("front.resourcectrl.tenantmanuscript.post", { id: 1 }, { reload: "front.resourcectrl.tenantmanuscript.post" });
                        // } else if (item.routerPart == "tenantManuscriptResource.receive") {
                        //     $state.go("front.resourcectrl.tenantmanuscript.receive", { id: 1 }, { reload: "front.resourcectrl.tenantmanuscript.receive" });
                        // }
                        deffer.resolve();
                    },
                    () => {
                        $scope.$root.narrowNavigation = true; // 窄导航
                        deffer.resolve();
                    }
                );

                return deffer.promise;
            };

            /**
             * [getTenantManuscriptLeve3Classify 查询租户团体3级分类]
             * @param  {[type]} item [description]
             * @return {[type]}      [description]
             */
            function getTenantManuscriptLeve3Classify(item) {
                let defer = $q.defer();
                getTenantList(item).then(
                    function() {
                        defer.resolve();
                    },
                    function() {
                        defer.reject();
                    }
                );
                return defer.promise;
            }

            /**
             * [getTenantList description] 获取租户团体列表
             * @param   {[type]}  item  [item description]
             * @return  {[type]}        [return description]
             */
            function getTenantList(item) {
                var defer = $q.defer();
                var params = {
                    serviceid: 'mlf_cooperationgroup',
                    methodname: 'queryGroupTenantsForMe',
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                    if (data.length > 0) {
                        item.value = data;
                        defer.resolve();
                    } else {
                        defer.reject();
                    }
                });
                return defer.promise;
            }

            /**
             * [selectMultiMediaResourceLeve2 description]
             * @param {[type]} [item] [description] 多媒体资源
             * @return {[type]} [description]
             */
            $scope.selectMultiMediaResourceLeve2 = function(item) {
                let deffer = $q.defer();
                getMultiMediaResourceClassify(item).then(
                    () => {
                        $scope.$root.narrowNavigation = false; // 宽导航
                        deffer.resolve();
                    },
                    function() {
                        $scope.$root.narrowNavigation = true; // 宽导航
                        deffer.resolve();
                    }
                );
                $scope.status.selected = item.routerPart;
                return deffer.promise;
            };

            /**
             * [getMultiMediaResourceClassify description] 获取多媒体资源分类子分类信息
             * @param  {[type]} item [description] 分类信息
             * @return {[type]}      [description]
             */
            function getMultiMediaResourceClassify(item) {
                let deffer = $q.defer();
                if (item.value) {
                    deffer.resolve();
                } else {
                    if (item.routerPart === 'multimediaresource.picture') {
                        getPictureClassify(item).then(
                            () => {
                                deffer.resolve();
                            },
                            () => {
                                deffer.reject();
                            }
                        );
                    } else if (item.routerPart === 'multimediaresource.video') {
                        getVideoClassify(item).then(
                            () => {
                                deffer.resolve();
                            },
                            () => {
                                deffer.reject();
                            }
                        );
                    }
                }

                /**
                 * [getPictureClassify description] 获取图片分类信息
                 * @param   {[type]}  item  [item description]
                 * @return  {[type]}        [return description]
                 */
                function getPictureClassify(item) {
                    let deffer = $q.defer();
                    let params = {
                        channelName: item.key,
                        containParent: false,
                        excludeId: -1,
                        level: 2,
                        modelid: 'base',
                        parentId: -1,
                        serviceid: 'navigation',
                        typeName: 'tp_lyzh',
                        typeid: 'zyzx',
                    };
                    $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post').then(
                        (data) => {
                            if (angular.isArray(data) && data.length > 0) {
                                item.value = data;
                                deffer.resolve();
                            } else {
                                deffer.reject();
                            }
                        },
                        () => {
                            deffer.reject();
                        }
                    );
                    return deffer.promise;
                }

                /**
                 * [getVideoClassify description]
                 * @param   {[type]}  item  [item description]
                 * @return  {[type]}        [return description]
                 */
                function getVideoClassify(item) {
                    let deffer = $q.defer();
                    let params = {
                        typeid: 'zyzx',
                        serviceid: 'navigation',
                        modelId: 'getWebVideoMedia',
                    };
                    $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post').then(
                        (data) => {
                            if (angular.isArray(data) && data.length > 0) {
                                item.value = data;
                                deffer.resolve();
                            } else {
                                deffer.reject();
                            }
                        },
                        () => {
                            deffer.reject();
                        }
                    );
                    return deffer.promise;
                }
                return deffer.promise;
            }

            /**
             * [getMultiMediaSelectedLeve2Info description] 获取多媒体资源选中的分类信息
             * @return {[type]} [description]
             */
            $scope.getMultiMediaSelectedLeve2Info = function() {
                return $scope.data.multiMediaResource.filter(
                    (item) => item.routerPart === $scope.status.selected && angular.isArray(item.value) && item.value.length > 0
                )[0];
            };

            /**
             * [selectMaterialsLeve1 description] 选中公共素材一级导航
             * @return {[type]} [description]
             */
            $scope.selectMaterialsLeve1 = function() {
                getMaterialsClassify().then(
                    () => {
                        $scope.$root.narrowNavigation = false; // 宽导航
                    },
                    () => {
                        $scope.$root.narrowNavigation = true; // 窄导航
                    }
                );
                resourceCenterService.memoryEchoOnlyLevel1('front.resourcectrl.materials');
                $scope.status.selected = 'materials';
            };

            /**
             * [getMaterialsClassify description] 获取公共素材分类信息
             * @return {[type]} [description]
             */
            function getMaterialsClassify() {
                let deffer = $q.defer();
                if ($scope.data.materials.value) {
                    deffer.resolve();
                    return deffer.promise;
                }
                let params = {
                    methodname: 'queryCategorysWithRight',
                    serviceid: 'mlf_sharedmaterial',
                    type: 2,
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(
                    (data) => {
                        if (angular.isArray(data) && data.length > 0) {
                            $scope.data.materials.value = data;
                            deffer.resolve();
                        } else {
                            deffer.reject();
                        }
                    },
                    () => {
                        deffer.reject();
                    }
                );
                return deffer.promise;
            }

            /**
             * [selectedPropagadaLeve1 选中宣传部稿库一级菜单]
             * @return {[type]} [description]
             */
            $scope.selectedPropagadaLeve1 = function() {
                getPropagandaClassify().then(
                    function() {
                        $scope.$root.narrowNavigation = false; // 宽导航
                    },
                    function() {
                        $scope.$root.narrowNavigation = true; // 窄导航
                    }
                );
                resourceCenterService.memoryEchoOnlyLevel1('front.resourcectrl.propagandamanuscript');
                $scope.status.selected = 'pmdocs';
            };

            /**
             * [getPropagandaClassify 获取宣传部稿库分类]
             * @return {[type]} [description]
             */
            function getPropagandaClassify() {
                var defer = $q.defer();
                var params = {
                    serviceid: 'mlf_pm',
                    methodname: 'getPMGroupTreeByTenantId',
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(
                    function(data) {
                        $scope.data.propagandaData.value = data.DATA;
                        defer.resolve();
                    },
                    function(error) {
                        defer.reject();
                    }
                );
                return defer.promise;
            }

            /**
             * [expandLeve1 description] 展开一级菜单
             * @param   {[type]}  type  [type description] 菜单类型
             * @param   {[type]}  e     [e description]
             * @return  {[type]}        [return description]
             */
            $scope.expandLeve1 = function(type, e) {
                let deffer = $q.defer();
                if ($scope.leve1IsExpanded(type)) {
                    $scope.status.expandedLeve1 = $scope.status.expandedLeve1.filter((item) => item.indexOf(type) < 0);
                    deffer.resolve();
                } else {
                    $scope.status.expandedLeve1.push(type);
                    if (e) {
                        resourceCenterService.memoryEchoLevel1(e, 'front.resourcectrl.' + type);
                    }
                    deffer.resolve();
                }
                return deffer.promise;
            };

            /**
             * [leve1IsExpanded description] 判断一级菜单是否展开
             * @param {[string]} [type] [description] 菜单类型
             * @return {[type]} [description]
             */
            $scope.leve1IsExpanded = function(type) {
                return $scope.status.expandedLeve1.some((item) => item.indexOf(type) >= 0);
            };

            /** ************************* 素材库导航开始 ******************* */

            /**
             * [expandMaterialClassify description] 展开素材库
             * @param   {[type]}  e  [e description]
             * @return  {[type]}     [return description]
             */
            $scope.expandMaterialClassify = function(e) {
                let deffer = $q.defer();
                getMaterialClassify().then(() => {
                    $scope.expandLeve1('material', e);
                    deffer.resolve();
                });
                return deffer.promise;
            };

            /**
             * [getxinhuaSecondClassify description] 获取素材库分类
             * @return {[type]} [description]
             */
            function getMaterialClassify() {
                let deffer = $q.defer();
                if (!$scope.data.materialClassify || $scope.data.materialClassify.length == 0) {
                    getMaterialNavData('navigation_007')
                        .then(function(data) {
                            return dealMaterialNavLevel2(data);
                        })
                        .then(function(data) {
                            $scope.data.materialClassify = data;
                            deffer.resolve();
                        });
                } else {
                    deffer.resolve();
                }
                return deffer.promise;
            }

            /**
             * [getMaterialNavData 获取素材库和媒资库的导航数据]
             *
             * @param   {[type]}  fcode  [fcode description]
             *
             * @return  {[type]}         [return description]
             */
            function getMaterialNavData(fcode) {
                let deffer = $q.defer();
                let requestParams = {
                    url: '/bigdata/mr/zyzx/navigation/getMeiziNavigation?parentId=' + fcode,
                    method: 'get',
                    contentType: 'application/x-www-form-urlencoded;charset=UTF-8',
                };
                let requestData = {};
                let successCode = '200';
                trsHttpService.httpServerForMR(requestParams, requestData).then(function(data) {
                    if (data.code === successCode) {
                        deffer.resolve(data.datas);
                    } else {
                        if (data.msg) {
                            modalDialog.alertType(data.msg, '', 'error', false, '');
                        } else {
                            modalDialog.alertType('请求发生错误', '', 'error', false, '');
                        }
                        deffer.reject([]);
                    }
                });
                return deffer.promise;
            }

            /**
             * [dealMaterialNavLevel2 处理素材库二级导航数据]
             *
             * @param   {[type]}  data  [data description]
             *
             * @return  {[type]}        [return description]
             */
            function dealMaterialNavLevel2(data) {
                let deffer = $q.defer();
                let maxCount = data.length;
                let count = 0;
                data.forEach(function(element, index) {
                    element.name = element.dictname;
                    element.fcode = element.dictid;
                    element.mrType = element.mrtype;
                    getMaterialNavData(element.dictid).then(function(navData) {
                        delete data[index].dictname;
                        delete data[index].dictid;
                        delete data[index].mrtype;
                        data[index].value = dealMaterialNavLevel3(navData);
                        count++;
                        if (count === maxCount) {
                            deffer.resolve(data);
                        }
                    });
                });
                return deffer.promise;
            }

            /**
             * [dealMaterialNavLevel3 处理素材库三级导航数据]
             *
             * @param   {[type]}  data  [data description]
             *
             * @return  {[type]}        [return description]
             */
            function dealMaterialNavLevel3(data) {
                let navData = [];
                data.forEach(function(element) {
                    let tmp = {};
                    tmp.name = element.dictname;
                    tmp.fcode = element.dictid;
                    tmp.mrType = element.mrtype;
                    tmp.resourceType = element.resourcetype;
                    navData.push(tmp);
                });
                return navData;
            }

            /**
             * [selectMaterialLeve2 description] 素材库选中二级菜单
             * @param  {[type]} item [description] 菜单信息
             * @param {boolean} [varname] [description] 是否重载页面
             * @return {[type]}      [description]
             */

            $scope.selectMaterialLeve2 = function(item, reload) {
                let deffer = $q.defer();
                if (angular.isArray(item.value) && item.value.length > 0) {
                    $scope.$root.narrowNavigation = false; // 宽导航
                } else {
                    $scope.$root.narrowNavigation = true; // 窄导航
                }
                $scope.status.selected = item.fcode;
                if (reload === false) {
                    deffer.resolve();
                    return deffer.promise;
                }
                var params = {
                    // resourcetype: item.fcode === $state.params.parentfcode ? $state.params.resourcetype : 2,
                    resourcetype: item.fcode === $state.params.parentfcode ? $state.params.resourcetype : item.value[0].resourceType, // 考虑到权限问题 不能写死
                    parentfcode: item.fcode,
                };
                if (item.fcode === 'navigation_007001') {
                    resourceCenterService.go('front.resourcectrl.material.personal', params);
                } else if (item.fcode === 'navigation_007002') {
                    resourceCenterService.go('front.resourcectrl.material.compile', params);
                } else {
                    resourceCenterService.go('front.resourcectrl.material.share', params);
                }
                deffer.resolve();
                return deffer.promise;
            };

            /**
             * [getXinhuaSelectedLeve2Info description] 获取选中的素材库二级信息
             * @return {[type]} [description]
             */
            $scope.getMaterialSelectedLeve2Info = function() {
                if (!$scope.materialLeftShow()) {
                    return {};
                }
                return $scope.data.materialClassify.filter(
                    (item) => item.fcode == $scope.status.selected && angular.isArray(item.value) && item.value.length > 0
                )[0];
            };

            /**
             * [materialLeftShow description] 素材库的三级菜单是否展示
             * @return {[type]} [description]
             */
            $scope.materialLeftShow = function() {
                if (!angular.isArray($scope.data.materialClassify) || $scope.data.materialClassify.length == 0) {
                    return false;
                }
                return $scope.data.materialClassify.some(
                    (item) => item.fcode == $scope.status.selected && angular.isArray(item.value) && item.value.length > 0
                );
            };

            /** ************************* 素材库导航结束 ******************* */

            /** ************************** 媒资库导航开始 ********************* */

            /**
             * [selectMediaResourceLeve1 description] 选中媒资库一级导航
             * @return {[type]} [description]
             */
            $scope.selectMediaResourceLeve1 = function() {
                getMediaResourceClassify().then(
                    (item) => {
                        $scope.$root.narrowNavigation = false; // 宽导航
                        let params = {
                            resourcetype: $state.params.resourcetype || item.resourceType || '2',
                        };
                        resourceCenterService.go('front.resourcectrl.mediaresource.resource', params);
                    },
                    () => {
                        $scope.$root.narrowNavigation = true; // 窄导航
                    }
                );
                resourceCenterService.memoryEchoOnlyLevel1('front.resourcectrl.mediaresource');
                setTimeout(function() {
                    $scope.status.selected = 'mediaresource';
                });
            };

            /**
             * [getMediaResourceClassify description] 获取公共素材分类信息
             * @return {[type]} [description]
             */
            function getMediaResourceClassify() {
                let deffer = $q.defer();
                if ($scope.data.mediaresource.value) {
                    deffer.resolve($scope.data.mediaresource.value[0]);
                    return deffer.promise;
                }
                getMaterialNavData('navigation_008').then(
                    function(data) {
                        if (angular.isArray(data) && data.length > 0) {
                            $scope.data.mediaresource.value = dealMaterialNavLevel3(data);
                            deffer.resolve($scope.data.mediaresource.value[0]);
                        } else {
                            deffer.reject();
                        }
                    },
                    function() {
                        deffer.reject();
                    }
                );
                return deffer.promise;
            }

            /**
             * [getxinhuaSecondClassify 获取新疆日报稿库渠道列表]
             *
             * @return  {[type]}  [return description]
             */
            function getXJRBClassifyNew() {
                let deffer = $q.defer();
                if ($scope.data.xjrb.value) {
                    if ($state.current.name === 'front.resourcectrl.xjrb.resource' || $state.current.name === 'front.resourcectrl.xjrb.quickpreview') {
                        deffer.resolve($state.params);
                    } else {
                        deffer.resolve($scope.data.xjrb.value[0]);
                    }
                    return deffer.promise;
                }
                let params = stockApiService.getChannelsParams();
                stockApiService.getChannels(params).then(
                    function(data) {
                        if (angular.isArray(data.content) && data.content.length > 0) {
                            $scope.data.xjrb.value = dealXJRBClassifys(data.content);
                            resourceCenterService.memoryEchoOnlyLevel1('front.resourcectrl.xjrb');
                            if ($state.current.name === 'front.resourcectrl.xjrb.resource' || $state.current.name === 'front.resourcectrl.xjrb.quickpreview') {
                                deffer.resolve($state.params);
                            } else {
                                deffer.resolve($scope.data.xjrb.value[0]);
                            }
                        } else {
                            deffer.reject();
                        }
                    },
                    function() {
                        deffer.reject();
                    }
                );
                return deffer.promise;
            }

            /**
             * [dealxinhuaSecondClassifys 处理新华社分类信息]
             *
             * @param   {[type]}  data  [data description]
             *
             * @return  {[type]}        [return description]
             */
            function dealxinhuaSecondClassifys(data) {
                let rs = [];
                data.forEach(function(item) {
                    let tmp = {
                        fcode: item.DOCCLASSIFYID,
                        nodename: item.DOCCLASSIFYNAME,
                    };
                    rs.push(tmp);
                });
                return rs;
            }

            /**
             * [dealxinhuaSecondClassifys 处理新疆日报渠道信息]
             *
             * @param   {[type]}  data  [data description]
             *
             * @return  {[type]}        [return description]
             */
            function dealXJRBClassifys(data) {
                // return data;
                let rs = [];
                data.forEach(function(item) {
                    let tmp = {
                        fcode: item.fcode,
                        nodename: item.name,
                    };
                    rs.push(tmp);
                });
                return rs;
            }

            /**
             * [getTenantManuscriptSelectedLeve2Info description] 获取特色资源选中的分类信息
             * @return  {[type]}  [return description]
             */
            $scope.getTenantManuscriptSelectedLeve2Info = function() {
                return $scope.data.tenantManuscriptResource.filter(
                    (item) => item.routerPart === $scope.status.selected && angular.isArray(item.value) && item.value.length >= 0
                )[0];
            };

            /**
             * 选择新疆日报历史稿库
             * @return {[type]} [return description]
             */
            $scope.selectXjrbHistoryStore = function() {
                $scope.status.selected = 'historystore';
                $scope.$root.narrowNavigation = true;
                resourceCenterService.go('front.resourcectrl.stock.resource', {
                    media_id: 'szbhistory542',
                    fcode: 'szb',
                    historystore: true,
                    change: Math.random()
                });
            };
        },
    ]);
